import domReady from '@wordpress/dom-ready';

domReady(function () {
	const BIG_IMAGE = document.querySelector(
		'.event-primary__hero-featured__image'
	);
	const GRID = document.querySelector('.event-primary__hero-featured__grid');
	const ACTIVE_INDEX = 0;

	if (BIG_IMAGE && GRID) {
		const GRID_ITEMS = GRID.querySelectorAll(
			'.event-primary__hero-featured__grid-item'
		);

		GRID_ITEMS[ACTIVE_INDEX].setAttribute('data-active', 'true');

		GRID_ITEMS.forEach((item, index) => {
			item.addEventListener('click', () => {
				// Remove the active attribute from all items
				GRID_ITEMS.forEach((gridItem) => {
					gridItem.removeAttribute('data-active');
				});

				// Add the active attribute to the clicked item
				GRID_ITEMS[index].setAttribute('data-active', 'true');

				// Swap the image
				const newImage = {
					src: item.getAttribute('src'),
					alt: item.getAttribute('alt'),
				};

				BIG_IMAGE.setAttribute('src', newImage.src);
				BIG_IMAGE.setAttribute('alt', newImage.alt);
			});
		});
	}
});
